// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1i6YK","clinicsSelect":"styles_clinicsSelect__1ytPi"};